// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RunQuarantinedRecord
 */
export interface RunQuarantinedRecord {
    /**
     * 
     * @type {string}
     * @memberof RunQuarantinedRecord
     */
    primaryKeyValue: string;
    /**
     * 
     * @type {string}
     * @memberof RunQuarantinedRecord
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof RunQuarantinedRecord
     */
    tableName: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RunQuarantinedRecord
     */
    values: { [key: string]: string; };
}

/**
 * Check if a given object implements the RunQuarantinedRecord interface.
 */
export function instanceOfRunQuarantinedRecord(value: object): value is RunQuarantinedRecord {
    if (!('primaryKeyValue' in value) || value['primaryKeyValue'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('tableName' in value) || value['tableName'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function RunQuarantinedRecordFromJSON(json: any): RunQuarantinedRecord {
    return RunQuarantinedRecordFromJSONTyped(json, false);
}

export function RunQuarantinedRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunQuarantinedRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'primaryKeyValue': json['primaryKeyValue'],
        'reason': json['reason'],
        'tableName': json['tableName'],
        'values': json['values'],
    };
}

export function RunQuarantinedRecordToJSON(json: any): RunQuarantinedRecord {
    return RunQuarantinedRecordToJSONTyped(json, false);
}

export function RunQuarantinedRecordToJSONTyped(value?: RunQuarantinedRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primaryKeyValue': value['primaryKeyValue'],
        'reason': value['reason'],
        'tableName': value['tableName'],
        'values': value['values'],
    };
}
